/*
 * File: FancyInput.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 09 Dec 2021 1:42:30 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import { Input, InputProps, InputRef } from 'antd';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { FC, useEffect, useRef, useState } from 'react';

interface FancyInputProps extends InputProps {
  width?: number;
}

const styles: InlineStylesModel = {
  form: {
    position: 'relative'
  },
  borderAnimation: {
    // transform: 'translateX(-100%)',
    transition: 'all 0.3s ease'
  },
  input: {
    width: '100%',
    minWidth: 125,
    borderRadius: 0
  },
  labelUnfocused: {
    position: 'absolute',
    color: 'rgba(0,0,0,0.50)',
    top: 5,
    left: 10,
    zIndex: 2,
    transition: 'all 0.3s ease',
    pointerEvents: 'none'
  },
  labelFocused: {
    backgroundColor: 'white',
    position: 'absolute',
    paddingLeft: 5,
    paddingRight: 5,
    zIndex: 2,
    top: -15,
    left: 8,
    transition: 'all 0.3s ease',
    borderRadius: 5
  },
  disabled: {
    cursor: 'not-allowed'
  }
};

export const FancyInput: FC<FancyInputProps> = ({ value, placeholder, width, disabled, ...rest }: FancyInputProps) => {
  const [isLabelTop, _setIsLabelTop] = useState(false);

  const inputRef = useRef<InputRef>(null);

  const inputWidth = width ? { ...styles.input, ...{ width } } : styles.input;

  const handleFocus = (): void => {
    _setIsLabelTop(true);
  };

  const onLabelClick = (): void => {
    if (!isLabelTop && inputRef.current) {
      _setIsLabelTop(true);
      inputRef.current.focus();
    }
  };

  const handleBlur = (): void => {
    if (!value && !rest.defaultValue && !inputRef.current?.input?.value && value !== 0) {
      _setIsLabelTop(false);
    }
  };

  useEffect(() => {
    if (value || value === 0) {
      _setIsLabelTop(true);
    }
  }, [value]);

  return (
    <div style={isLabelTop ? { ...styles.form, ...styles.borderAnimation } : styles.form}>
      <Input {...rest} ref={inputRef} value={value} disabled={disabled} style={inputWidth} onFocus={handleFocus} onBlur={handleBlur} allowClear />
      <label style={disabled ? { ...styles.disabled, ...styles.labelUnfocused } : isLabelTop ? styles.labelFocused : styles.labelUnfocused} onClick={onLabelClick}>
        <span>{placeholder}</span>
      </label>
    </div>
  );
};
